import { connect } from 'react-redux';
import KTPList from '../../components/ktp/KTPList';

const mapStateToProps = ({ktp}) => ({
  list: ktp.list,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(KTPList);
